import { OAuthRedirectBtn } from '@playbooks/components/oauth/oauth-redirect-btn';

const GithubRedirectBtn = ({ url, params = {}, popup = false, onNext = undefined, children = null, ...props }) => {
	return (
		<OAuthRedirectBtn
			provider='GitHub'
			callbackType='onGithub'
			storageKey='githubAuthorizationParams'
			url={url}
			params={params}
			popup={popup}
			onNext={onNext}
			{...props}>
			{children}
		</OAuthRedirectBtn>
	);
};

export { GithubRedirectBtn };
